import { ActionType } from "../ChatAction";
import { VisualState } from "../ChatState";

export default function setVisualStatus(status: VisualState): ActionType {
    return {
        type: "visual_status",
        detail: {
            status,
            timestamp: new Date().getTime()
        }
    };
}